// Core
import React, { useState, useEffect } from "react"
import { useTriggerTransition } from "gatsby-plugin-transition-link"

// Components
import { setCursorState } from "../cursor/set"

// Styles
import styles from "./pagination.module.scss"

// Assets
import Bg from "./assets/bg.inline.svg"
import NarrowBg from "./assets/narrowBg.inline.svg"
import Texture from "./assets/texture.png"
import NarrowTexture from "./assets/narrowTexture.png"

// Data
import pages from "./../../data/pages"

const PaginationItem = ({
  index,
  title,
  slug,
  label,
  current,
  leaveEvent,
  newIndex,
}) => {
  const letters = title.split("")

  const triggerTransition = useTriggerTransition({
    entry: {
      delay: 0,
      zIndex: 10,
    },
  })

  return (
    <li
      className={`${styles.item} ${current ? styles.current : ""}`}
      onClick={() =>
        {
          triggerTransition({
            to: "/" + slug,
            exit: {
              trigger: leaveEvent,
              length: index === 9 || newIndex === 9 ? 0 : 6,
              zIndex: 5,
            },
          })
        }
      }
    >
      <div className={styles.title}>
        {letters.length > 16 ? (
          <React.Fragment>
            <Bg />
            <img
              className={styles.texture}
              src={Texture}
              width={221}
              height={47}
              alt=""
            />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <NarrowBg />
            <img
              className={styles.texture}
              src={NarrowTexture}
              width={161}
              height={47}
              alt=""
            />
          </React.Fragment>
        )}
        {letters.map((letter, i) => (
          <span key={`pagination-title-${index}-${i}`}>
            {letter !== " " ? letter : "\u00A0"}
          </span>
        ))}
      </div>
    </li>
  )
}

const Pagination = ({ index, leaveEvent }) => {
  const [reveal, setReveal] = useState(false)

  // Animate in
  useEffect(() => {
    let revealTimeout = null

    if (index === 9) {
      setReveal(true)
    } else {
      revealTimeout = setTimeout(() => {
        setReveal(true)
      }, 5000)
    }

    return () => {
      if (revealTimeout) clearTimeout(revealTimeout)
    }
  }, [])

  return (
    <div
      className={`${styles.pagination} ${reveal ? styles.visible : ""} ${
        index === 9 ? styles.white : ""
      }`}
      onMouseEnter={() => setCursorState("pointer", true)}
      onMouseLeave={() => setCursorState("pointer", false)}
    >
      <ul className={styles.itemList}>
        {pages.map(page => (
          <PaginationItem
            key={`pagination-item-${page.index}`}
            {...page}
            current={index === page.index}
            leaveEvent={leaveEvent}
            index={index}
            newIndex={page.index}
          />
        ))}
      </ul>
    </div>
  )
}

export default Pagination
